import DirectDebitBacsMandate from './direct-debit-bacs-mandate';

export default DirectDebitBacsMandate;
